import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { ImageModule } from 'primeng/image';
import { DialogModule } from 'primeng/dialog';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { ExecutionResultService } from 'src/app/services/execution-result.service';
import { FuntionalAreaService } from 'src/app/modules/test-suite/services/test-suite.service';
import { ScenarioService } from '../../scenario/services/scenario.service';
import { PackagesService } from '../../packages/services/packages.service';
import { ExecutionResultViewModel } from '../viewmodels/execution-result-viewmodel';
import { MultiSelect } from 'primeng/multiselect';
import { AuthService } from '../../../auth/login/services/auth.service';
import { ClientService } from '../../client/services/client.service';


@Component({
    selector: 'app-execution-result',
    imports: [
        CommonModule,
        TableModule,
        TreeTableModule,
        ButtonModule,
        TagModule,
        ImageModule,
        DialogModule,
        ToolbarModule,
        TooltipModule,
        InputTextModule,
        SelectModule,
        DatePickerModule,
        FormsModule,
        PaginatorModule,
        MultiSelect
    ],
    templateUrl: './execution-result.component.html',
    styleUrls: ['./execution-result.component.scss']
})
export class ExecutionResultComponent implements OnInit, OnDestroy {
  private http = inject(HttpClient);
  private executionResultService = inject(ExecutionResultService);
  private funtionalAreaService = inject(FuntionalAreaService);
  private scenarioService = inject(ScenarioService);
  private packageService = inject(PackagesService);
  private authService = inject(AuthService);
  private clientService = inject(ClientService);
  private route = inject(ActivatedRoute);
  public viewModel!: ExecutionResultViewModel;
  private queryParamSub?: Subscription;

  ngOnInit(): void {
    this.viewModel = new ExecutionResultViewModel(
      this.http,
      this.executionResultService,
      this.funtionalAreaService,
      this.scenarioService,
      this.authService,
      this.clientService
    );
    this.viewModel.init();

    // Subscribe reactively so re-navigation to this route with new params also triggers
    this.queryParamSub = this.route.queryParamMap.subscribe(params => {
      const executionRunId = params.get('executionRunId');
      const scenarioIdsRaw = params.get('scenarioIds');
      if (executionRunId) {
        this.viewModel.applyNotificationFilters(executionRunId, scenarioIdsRaw, {
          clientId: params.get('clientId'),
          packageId: params.get('packageId'),
          functionalAreaId: params.get('functionalAreaId'),
          testTypeId: params.get('testTypeId'),
          tenantId: params.get('tenantId'),
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.queryParamSub?.unsubscribe();
  }


  // Delegate methods to ViewModel
  clearResults() { this.viewModel.clearResults(); }
  exportResults() { this.viewModel.exportResults(); }

  getStatusSeverity(status: string) { return this.viewModel.getStatusSeverity(status); }
  getReadableStatus(result: any) { return this.viewModel.getReadableStatus(result); }
  getStepStatus(step: any) { return this.viewModel.getStepStatus(step); }
  formatDuration(ms: number | undefined) { return this.viewModel.formatDuration(ms); }
  parseLogText(logText: string) { return this.viewModel.parseLogText(logText); }

  // loadPackages() { this.viewModel.loadPackages(); }
  onPackageChange(event: any) { this.viewModel.onPackageChange(event.value); }
  onScenarioChange(event: any) { this.viewModel.onScenarioChange(event.value); }

  // Split-view delegates
  onFaTabChange(faId: string) { this.viewModel.onFaTabChange(faId); }
  onScenarioPageChange(event: any) { this.viewModel.onScenarioPageChange(event); }
  onScenarioSelect(scenarioId: string, executionRunId?: string) { this.viewModel.onScenarioSelect(scenarioId, executionRunId); }
  onStepExpand(stepId: string) { this.viewModel.onStepExpand(stepId); }
  onScenarioSearchChange(text: string) { this.viewModel.onScenarioSearchChange(text); }
}


